import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdAccount } from "@/contexts/AdAccountContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings2 } from "lucide-react";
import { ReactNode } from "react";

export function RequiresConfiguredAccount({ children }: { children: ReactNode }) {
  const { selectedAdAccountId, activeAccountSetupStatus, isLoading } = useAdAccount();
  const navigate = useNavigate();

  // While loading, don't flash the guard
  if (isLoading || activeAccountSetupStatus === null) {
    return <>{children}</>;
  }

  if (activeAccountSetupStatus !== "completed") {
    return (
      <div className="flex items-center justify-center min-h-[60vh] px-4">
        <Card className="max-w-md w-full">
          <CardContent className="flex flex-col items-center text-center gap-4 pt-8 pb-8">
            <div className="rounded-full bg-muted p-3">
              <Settings2 className="h-8 w-8 text-muted-foreground" />
            </div>
            <div className="space-y-1.5">
              <h2 className="text-lg font-semibold text-foreground">
                Account setup required
              </h2>
              <p className="text-sm text-muted-foreground">
                This ad account needs to be configured before you can create ads.
              </p>
            </div>
            <Button
              onClick={() => navigate(selectedAdAccountId ? `/setup/account/${selectedAdAccountId}` : "/onboarding/setup")}
              className="mt-2"
            >
              Complete Setup
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
